export const inboxConstants = {
  /*********
   수신함 검색조건 변경
   **********/
  SELECT_SEARCH_REQUEST: 'SELECT_INBOX_SEARCH_REQUEST',

  /*********
   수신함 목록 조회
   **********/
  INBOX_REQUEST: 'GET_INBOX_REQUEST',
  INBOX_SUCCESS: 'GET_INBOX_SUCCESS',
  INBOX_FAILURE: 'GET_INBOX_FAILURE',
  INBOX_ORG_REQUEST: 'GET_INBOX_ORG_REQUEST',
  INBOX_ORG_SUCCESS: 'GET_INBOX_ORG_SUCCESS',
  INBOX_ORG_FAILURE: 'GET_INBOX_ORG_FAILURE',

  /*********
   증명서 삭제
   **********/
  DELETE_REQUEST: 'DELETE_INBOX_REQUEST',
  DELETE_SUCCESS: 'DELETE_INBOX_SUCCESS',
  DELETE_FAILURE: 'DELETE_INBOX_FAILURE',

  /***********
   증명서 제출
   ************/
  SUBMIT_REQUEST: 'SUBMIT_CERTIFICATE_REQUEST',
  SUBMIT_SUCCESS: 'SUBMIT_CERTIFICATE_SUCCESS',
  SUBMIT_FAILURE: 'SUBMIT_CERTIFICATE_FAILURE',

  /***********
   증명서 반려
   ************/
  REJECT_REQUEST: 'REJECT_CERTIFICATE_REQUEST',
  REJECT_SUCCESS: 'REJECT_CERTIFICATE_SUCCESS',
  REJECT_FAILURE: 'REJECT_CERTIFICATE_FAILURE',

  /***********
   증명서 수취완료료
  ************/
  RECEIVE_REQUEST: 'RECEIVE_CERTIFICATE_REQUEST',
  RECEIVE_SUCCESS: 'RECEIVE_CERTIFICATE_SUCCESS',
  RECEIVE_FAILURE: 'RECEIVE_CERTIFICATE_FAILURE',

  /*********
   증명서 상세선택
   **********/
  SELECT_REQUEST: 'SELECT_INBOX_REQUEST',

  /*********
   수신함 상세 조회
   **********/
  DETAIL_REQUEST: 'GET_INBOX_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'GET_INBOX_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'GET_INBOX_DETAIL_FAILURE',

  /***********
   증명서 제출 수신자 SELECT 팝업 오픈
   ************/
  OPEN_RECEIVER_REQUEST: 'OPEN_RECEIVER_REQUEST',

  /***********
   증명서 제출 수신자 추가
   ************/
  ADD_RECEIVER_REQUEST: 'ADD_RECEIVER_REQUEST',

  /***********
   증명서 제출 첨부문서 row 최신화
   ************/
  CHANGE_FILE_REQUEST: 'CHANGE_INBOX_FILE_REQUEST',

  /*********
   최근 보낸 주소 조회
   **********/
  SELECT_RECENT_REQUEST: 'SELECT_RECENT_RECEIVER_REQUEST',
  SELECT_RECENT_SUCCESS: 'SELECT_RECENT_RECEIVER_SUCCESS',
  SELECT_RECENT_FAILURE: 'SELECT_RECENT_RECEIVER_FAILURE',

  /*********
   전자지갑주소 조회
   **********/
  WALLET_REQUEST: 'SELECT_WALLET_REQUEST',
  WALLET_SUCCESS: 'SELECT_WALLET_SUCCESS',
  WALLET_FAILURE: 'SELECT_WALLET_FAILURE',

  /*********
   전자지갑이름 조회
   **********/
  WALLET_NAME_REQUEST: 'SELECT_WALLETNAME_REQUEST',
  WALLET_NAME_SUCCESS: 'SELECT_WALLETNAME_SUCCESS',
  WALLET_NAME_FAILURE: 'SELECT_WALLETNAME_FAILURE',

  /***********
   증명서 제출 전자지갑 리스트 초기화
   ************/
  RESET_RECEIVER: 'RESET_RECEIVER',

  /***********
   증명서 구매확인서 상세조회
   ************/
  PCRL_REQUEST: 'SELECT_PCRL_REQUEST',
  PCRL_SUCCESS: 'SELECT_PCRL_SUCCESS',
  PCRL_FAILURE: 'SELECT_PCRL_FAILURE',

  /***********
   증명서 간접수출실적 상세조회
   ************/
  CRTF_REQUEST: 'SELECT_CRTF_REQUEST',
  CRTF_SUCCESS: 'SELECT_CRTF_SUCCESS',
  CRTF_FAILURE: 'SELECT_CRTF_FAILURE',

  /***********
   증명서 수신함 히스토리 관리
   ************/
  INBOX_HISTORY: 'SET_INBOX_HISTORY',

  /***********
   증명서 PDF BASE64STRING 조회
   ************/
  PDF_REQUEST: 'PDT_REQUEST',
  PDF_SUCCESS: 'PDF_SUCCESS',
  PDF_FAILURE: 'PDF_FAILURE',

  /***********
   PDF 호출 init 처리
   ************/
  INIT_FLAG_REQUEST: 'INIT_FLAG_REQUEST',

  /***********
   상태관련 state 초기화
   ************/
  CLEAR_REQUEST: 'CLEAR_REQUEST',

  /***********
   증명서 첨부파일 다운로드
   ************/
  FILE_REQUEST: 'FILE_REQUEST',
  FILE_SUCCESS: 'FILE_SUCCESS',
  FILE_FAILURE: 'FILE_FAILURE',

  /*********
   수신함 발급 요청
   **********/
  SUB_SENT_DOC_PDF_REQUEST: 'SUB_SENT_DOC_PDF_REQUEST',
  SUB_SENT_DOC_PDF_SUCCESS: 'SUB_SENT_DOC_PDF_SUCCESS',
  SUB_SENT_DOC_PDF_FAILURE: 'SUB_SENT_DOC_PDF_FAILURE',  
}